import React from 'react';
import styled from 'styled-components';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_discovery.ported_resume');

const NOTE_FONT_SIZE = '12px';
const NOTE_LINE_HEIGHT = '16px';

const Note = styled(SecondaryBody)`
  font-size: ${NOTE_FONT_SIZE};
  line-height: ${NOTE_LINE_HEIGHT};
`;

const MyGreenhouseProfileNote = ({ className }: { className?: string }) => (
  <Note
    as="span"
    metadata
    className={className}
    data-provides="my-greenhouse-profile-note"
  >
    {t('my_greenhouse_profile_note')}
  </Note>
);

export default MyGreenhouseProfileNote;
